/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response for POST /user/link-classic-account.
 */
export interface LinkClassicAccountResponse {
  /** Whether the Curai Classic account was linked */
  linked: boolean;
}
